import { Checkbox } from '~/common/components/ui/checkbox';
import { useTranslation } from 'react-i18next';
import { useSalesordersetFilter } from '~/features/catalog/routes/resources/SalesOrderSetFilterRoute';
import { useCallback } from 'react';
import { cn } from '~/common/utils/styleUtil';
import { useUiContext } from '~/common/components/context/useUiContext.ts';
import { useNavigation } from 'react-router';
import { useBasePath } from '~/common/hooks/useBasePath.ts';

interface SalesOrderSetFilterProps {
  className?: string;
}

export function SalesOrderSetFilter({ className }: Readonly<SalesOrderSetFilterProps>) {
  const { t } = useTranslation();
  const navigation = useNavigation();
  const { path } = useBasePath();
  const { isFilterAvailable, isActive, setSalesOrdersetFilter } = useSalesordersetFilter();
  const { isSearchFilterInProgress, setIsSearchFilterInProgress } = useUiContext();
  const isLoading = navigation.state === 'loading' && navigation.location.pathname === `${path}/catalog`;
  const isSearchFilterDisabled = isSearchFilterInProgress || isLoading;
  const onSalesOrderSetFilterChange = useCallback(() => {
    if (!isSearchFilterInProgress) {
      setIsSearchFilterInProgress(true);
      setSalesOrdersetFilter(!isActive);
    }
  }, [isSearchFilterInProgress, setIsSearchFilterInProgress, setSalesOrdersetFilter, isActive]);

  if (!isFilterAvailable) {
    return null;
  }

  return (
    <div className={cn('flex items-center space-x-2 min-h-8', className)}>
      <Checkbox
        checked={isActive}
        id="salesOrderSetFilter"
        data-testid={'salesOrdersetFilter'}
        onCheckedChange={onSalesOrderSetFilterChange}
        disabled={isSearchFilterDisabled}
      />
      <label
        htmlFor="salesOrderSetFilter"
        className="text-sm font-medium text-nowrap leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
      >
        {t('Gekaufte Artikel')}
      </label>
    </div>
  );
}
